import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import type { MenuCategory } from "@/lib/api/types";
import { CategoriesEditor } from "./CategoriesEditor";

type ManageCategoriesDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  storeId: string;
  categories: MenuCategory[];
  onRefresh: () => void;
};

export function ManageCategoriesDialog({
  open,
  onOpenChange,
  storeId,
  categories,
  onRefresh,
}: ManageCategoriesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Manage Categories</DialogTitle>
        </DialogHeader>
        <CategoriesEditor storeId={storeId} categories={categories} onRefresh={onRefresh} />
      </DialogContent>
    </Dialog>
  );
}
